import BaseProvider from './providers/BaseProvider';

class Analytics
{
    constructor(provider)
    {
        this.setProvider(provider);
    }

    trackEvent({name, details = {}, trackingOptions = {}})
    {
        if (typeof name !== 'string' || name === '') {
            return;
        }

        if (this.isInitialised() === false) {
            return;
        }

        this.provider.trackEvent({name, details, trackingOptions});
    }

    resetIdentity()
    {
        if (this.isInitialised() === false) {
            return;
        }

        this.provider.resetIdentity();
    }

    isInitialised()
    {
        return this.isProviderSet() && this.provider.isInitialised();
    }

    isProviderSet()
    {
        return this.provider != null;
    }

    setProvider(provider)
    {
        if (isValidProvider(provider) === false) {
            return;
        }

        this.provider = provider;

        if (this.provider.isInitialised()) {
            return;
        }

        this.provider.init();
    }
}

const isValidProvider = (analyticsProvider) => {
    if (analyticsProvider == null) {
        return false;
    }

    return analyticsProvider instanceof BaseProvider;
};

export default Analytics;
